import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-procedures-dental-chart",
  templateUrl: "./procedures-dental-chart.component.html",
  styleUrls: ["./procedures-dental-chart.component.scss"],
})
export class ProceduresDentalChartComponent implements OnInit {
  constructor() {}
  ngOnInit(): void {}

  DentalChartModel() {
    document.getElementById("DentalChartModel").style.display = "block";
  }
  closeDentalChartModel() {
    document.getElementById("DentalChartModel").style.display = "none";
  }
}
